import { render, staticRenderFns } from "./RemissionAdd.vue?vue&type=template&id=ef36896c"
import script from "./RemissionAdd.vue?vue&type=script&lang=js"
export * from "./RemissionAdd.vue?vue&type=script&lang=js"
import style0 from "./RemissionAdd.vue?vue&type=style&index=0&id=ef36896c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports